import config from '../../../../config';
import { stringValuesToNumbers } from '../../../../util/data';
import {
  convertUnitToSubUnit,
  getMultipliedPriceStr,
  unitDivisor,
} from '../../../../util/currency';

const unitDivisorValue = unitDivisor(config.currency);

export const getFieldMinAmountProps = (intl, currency, values) => {
  const valuesAsNumber = stringValuesToNumbers(values);
  const { price = 0 } = valuesAsNumber;
  const priceWithSubUnit = convertUnitToSubUnit(price, unitDivisorValue);

  return [
    {
      id: '1',
      price: getMultipliedPriceStr(intl, priceWithSubUnit, currency),
      selected: values.minAmountPerHour
    },
    {
      id: '2',
      price: getMultipliedPriceStr(intl, priceWithSubUnit, currency, 2),
      selected: values.minAmountPerHour
    },
    {
      id: '3',
      price: getMultipliedPriceStr(intl, priceWithSubUnit, currency, 3),
      selected: values.minAmountPerHour
    },
    {
      id: '4',
      price: getMultipliedPriceStr(intl, priceWithSubUnit, currency, 4),
      selected: values.minAmountPerHour
    },
    {
      id: '5',
      price: getMultipliedPriceStr(intl, priceWithSubUnit, currency, 5),
      selected: values.minAmountPerHour
    }
  ]
};


